(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-tabs"]) return;
  try {
    
  class TabSliderComponent extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll('.tabs-list li');
      this.sliders = this.querySelectorAll('[id^="Tab-Slider"]');
      this.productsToShow = parseInt(this.getAttribute('data-products-to-show'), 10);
      this.id = this.getAttribute('data-id');

      this.fetchCollectionData();

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const collectionHandle = tab.getAttribute('data-collection-tab-handle');
          this.tabs.forEach((tab) => tab.classList.remove('active'));
          tab.classList.add('active');

          this.sliders.forEach((slider) => {
            if (slider.getAttribute('data-collection-handle') === collectionHandle && collectionHandle !== '') {
              slider.style.display = 'block';
            } else {
              slider.style.display = 'none';
            }
          });
        });
      });
    }

    async fetchCollectionData() {
      try {
        // Loop through each tab
        this.tabs.forEach(async (tab) => {
          // Skip the tab if it is already active
          if (tab.classList.contains('active')) return;

          // Get the collection handle from the tab's data attribute
          const collectionHandle = tab.getAttribute('data-collection-tab-handle');

          // Fetch the collection page HTML
          const response = await fetch(`/collections/${collectionHandle}`);
          const htmlText = await response.text();

          // Parse the HTML response
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlText, 'text/html');

          // Select product cards
          let products = doc.querySelectorAll('.product-card');
          products = Array.from(products).slice(0, this.productsToShow);

          // Here you can insert the products into the DOM if needed, e.g., by adding them to a slider or grid
          products.forEach((product, index) => {
            const li = document.querySelector('[data-tab-slide="' + tab.textContent.trim() + '-' + (index + 1) + '"]');
            if (li) {
              li.innerHTML = product.outerHTML;
            }
          });
        });
      } catch (error) {
        console.error('Error fetching collection data:', error);
      }
    }
  }
  customElements.define('tab-slider-component', TabSliderComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subcollection-nav"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const slider1 = document.getElementById('Slider-1');
    const slider2 = document.getElementById('Slider-2');

    if (slider1 && slider2) {
      const back = document.querySelector('.subcollection-nav__back');
      const forward = document.querySelector('.subcollection-nav__forward');

      if (back) {
        back.addEventListener('click', function () {
          slider1.style.display = 'block';
          slider2.style.display = 'none';
        });
      }

      if (forward) {
        forward.addEventListener('click', function () {
          slider1.style.display = 'none';
          slider2.style.display = 'block';
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
